import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as AsymmetryVariableRangesActions from '../actions/asymmetry-variable-ranges.actions';
import { AsymmetryVariableRanges } from '@sleipai/sleip-models';

export const asymmetryVariableRangesesFeatureKey = 'asymmetryVariableRangeses';

export interface State extends EntityState<AsymmetryVariableRanges> {
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export const adapter: EntityAdapter<AsymmetryVariableRanges> =
  createEntityAdapter<AsymmetryVariableRanges>({
    selectId: selectAsymmetryVariableRangesId,
    sortComparer: sortByType,
  });

export const initialState: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

export function selectAsymmetryVariableRangesId(
  asymmetryVariableRange: AsymmetryVariableRanges
) {
  return asymmetryVariableRange.id ?? '';
}

export function sortByType(
  a: AsymmetryVariableRanges,
  b: AsymmetryVariableRanges
) {
  return a.id.localeCompare(b.id);
}

export const asymmetryVariableRangeReducer = createReducer(
  initialState,

  on(AsymmetryVariableRangesActions.loadAsymmetryVariableRanges, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(
    AsymmetryVariableRangesActions.loadAsymmetryVariableRangesSuccess,
    (state, { data }) =>
      adapter.upsertMany(data, {
        ...state,
        loaded: true,
        loading: false,
      })
  ),
  on(
    AsymmetryVariableRangesActions.loadAsymmetryVariableRangesFailure,
    (state, { error }) => {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: error.message,
      };
    }
  )
);

export const {
  selectIds: selectAsymmetryVariableRangeIdsAdapter,
  selectEntities: selectAsymmetryVariableRangeEntitiesAdapter,
  selectAll: selectAllAsymmetryVariableRangesAdapter,
  selectTotal: selectAsymmetryVariableRangeTotalAdapter,
} = adapter.getSelectors();

export function reducer(state: State | undefined, action: Action) {
  return asymmetryVariableRangeReducer(state, action);
}
